import { authStoreFactory } from 'shared/store'

export const useAuthStore = authStoreFactory()
export const useAuthActions = () => useAuthStore(state => state.actions)
